<template>
  <div class="w-full h-full relative" :key="$route.params.contentType">
    <PageContetList v-if="['law'].includes($route.params.contentType)" />
    <PageProduct v-else-if="[
      'uav_catalog',
    ].includes($route.params.contentType)" />
    <ExperProfieletList v-else-if="[
      'pilots',
    ].includes($route.params.contentType)" />
    <PageContent v-else />
  </div>
</template>

<script>
import PageContent from '@/views/pages/PageContent.vue';
import PageProduct from '@/views/pages/PageProduct.vue';
import PageContetList from '@/views/pages/PageContetList.vue';
import ExperProfieletList from '@/views/client/ExperProfieletList.vue';
import { mapState } from 'vuex';

export default {
  computed: mapState(['user']),
  mounted() {
    if (!this.user.role && this.$route.params.contentType == 'pilots') {
      this.$router.push({ name: 'ClientIndex' });
    }
  },
  components: {
    PageContent,
    PageProduct, ExperProfieletList,
    PageContetList,
  },
};
</script>
